export default "__VITE_ASSET__d92e36ac__"